/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_0_TitleInputs */

const en_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 PGA of America Deacon Palmer Award`)
};

const es_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio Deacon Palmer 2024 de la PGA of America`)
};

const de_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-Preis 2024 der PGA of America`)
};

const zh_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 年 PGA of America Deacon Palmer 奖`)
};

const ar_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جائزة Deacon Palmer لعام 2024 من PGA of America`)
};

const fr_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix Deacon Palmer 2024 de la PGA of America`)
};

const vi_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giải thưởng Deacon Palmer 2024 của PGA of America`)
};

const sw_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuzo ya Deacon Palmer ya PGA of America ya 2024`)
};

const th_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัล Deacon Palmer ของ PGA of America ประจำปี 2024`)
};

const bs_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagrada Deacon Palmer 2024 od PGA of America`)
};

const ja_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024年 PGA of America Deacon Palmer賞`)
};

const ko_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 PGA of America Deacon Palmer 상`)
};

const pt_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmio Deacon Palmer 2024 da PGA of America`)
};

const it_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio Deacon Palmer della PGA of America 2024`)
};

const sv_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-priset från PGA of America 2024`)
};

const nl_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer Award 2024 van de PGA of America`)
};

const da_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-prisen 2024 fra PGA of America`)
};

const nb_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deacon Palmer-prisen 2024 fra PGA of America`)
};

const fi_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA of American Deacon Palmer -palkinto 2024`)
};

const pl_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagroda Deacon Palmer PGA of America 2024`)
};

const ru_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премия Deacon Palmer 2024 от PGA of America`)
};

const tr_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA of America 2024 Deacon Palmer Ödülü`)
};

const hi_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA of America का 2024 Deacon Palmer पुरस्कार`)
};

const id_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghargaan Deacon Palmer 2024 dari PGA of America`)
};

const ms_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anugerah Deacon Palmer PGA of America 2024`)
};

const cs_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena Deacona Palmera od PGA of America (2024)`)
};

const el_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βραβείο Deacon Palmer 2024 της PGA of America`)
};

const he_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרס Deacon Palmer של PGA of America 2024`)
};

const af_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 PGA of America Deacon Palmer-toekenning`)
};

const hu_about_content_honor_1_item_0_title = /** @type {(inputs: About_Content_Honor_1_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A PGA of America 2024-es Deacon Palmer-díja`)
};

/**
* | output |
* | --- |
* | "2024 PGA of America Deacon Palmer Award" |
*
* @param {About_Content_Honor_1_Item_0_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_0_title = /** @type {((inputs?: About_Content_Honor_1_Item_0_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_0_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_0_title(inputs)
	if (locale === "de") return de_about_content_honor_1_item_0_title(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_0_title(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_0_title(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_0_title(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_0_title(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_0_title(inputs)
	if (locale === "th") return th_about_content_honor_1_item_0_title(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_0_title(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_0_title(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_0_title(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_0_title(inputs)
	if (locale === "it") return it_about_content_honor_1_item_0_title(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_0_title(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_0_title(inputs)
	if (locale === "da") return da_about_content_honor_1_item_0_title(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_0_title(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_0_title(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_0_title(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_0_title(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_0_title(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_0_title(inputs)
	if (locale === "id") return id_about_content_honor_1_item_0_title(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_0_title(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_0_title(inputs)
	if (locale === "el") return el_about_content_honor_1_item_0_title(inputs)
	if (locale === "he") return he_about_content_honor_1_item_0_title(inputs)
	if (locale === "af") return af_about_content_honor_1_item_0_title(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_0_title(inputs)
	return en_about_content_honor_1_item_0_title(inputs)
});